<script setup lang="ts">
import { onMounted } from 'vue';
import { useRelayHubStore } from '@/store';
import OrganizationTable from './components/OrganizationTable.vue';
import StateTable from './components/StateTable.vue';
import { storeToRefs } from 'pinia';

const relayHubStore = useRelayHubStore();
const { data } = storeToRefs(relayHubStore);

const getConfig = async () => {
  await relayHubStore.fetchRelayHubConfig();
};

const getOrganizations = async () => {
  await relayHubStore.fetchOrganizations();
};

const getStates = async () => {
  await relayHubStore.fetchMedicaidEnabledStates();
};

const init = async () => {
  getConfig();
  await getStates();
  await getOrganizations();
};

onMounted(async () => {
  init();
});
</script>

<template>
  <Card class="mt-0 pt-0">
    <template #header>
      <h2>
        RelayHub
        <Icon
          v-if="data"
          v-tooltip.bottom="{
            value: `Host : ${data.host}:${data.port}`,
            escape: true,
            fitContent: true,
          }"
          name="info"
          class="text-primary-500 text-base cursor-pointer"
        />
      </h2>
    </template>
    <template #content>
      <div class="flex top-container pb-6">
        <StateTable @reset="init" />
      </div>
      <div class="flex pt-4">
        <OrganizationTable @reset="init" />
      </div>
    </template>
  </Card>
</template>

<style scoped lang="scss">
.top-container {
  border-bottom: 3px solid var(--primary-color-light) !important;
}
</style>
